import {
  IError,
  IProfile,
  IQueryHookOptions,
  IUpdateProfileRequest,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { updateProfile } from 'services';

type UpdateProfileFunction = UseMutateAsyncFunction<
  IProfile,
  IError,
  IUpdateProfileRequest
>;

type UseUpdateProfile = [UpdateProfileFunction, IQueryHookOptions];

export const useUpdateProfile = (profileId = ''): UseUpdateProfile => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IProfile,
    IError,
    IUpdateProfileRequest
  >((values: IUpdateProfileRequest) => updateProfile(profileId, values), {
    onSuccess: (data) => {
      queryClient.setQueryData(['profiles', profileId], data);
    },
  });

  return [mutateAsync, { error, isError, isLoading }];
};
